import { defineAction } from '~/prix'
import { z } from 'zod'
import variableItemsExportAction from './variableItemsExport.action.json' with { type: 'json' }

const optionalLooseObject = z.preprocess(
  value => (value == null ? undefined : value),
  z.object({}).passthrough().optional(),
)

const variableItemsExportDefinition = defineAction({
  ...variableItemsExportAction,
  input: z.object({
    format: z.enum(['xlsx', 'csv']).optional(),
    variable: z.object({}).passthrough(),
    filter: optionalLooseObject,
    highlight: optionalLooseObject,
    space: optionalLooseObject,
    time: optionalLooseObject,
    select: z.array(z.string().trim().min(1)).optional(),
    maxItems: z.number().int().positive().optional(),
  }),
  output: z.object({}).passthrough(),
})

export default variableItemsExportDefinition
